import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { getPrimeShortName } from '@/helpers/promotion-helper';
import { useExperiment } from '@/libraries/experiment';
import { computed } from 'vue';

export function useOverProviderExp() {
	const { country } = useLanguageStore();
	const { activeVariantWithControlGroup: overProviderExpVariant } = useExperiment('OVER_PROVIDER_EXP_V3');

	const kickedInOverProviderShortName = computed<string | null>(() => {
		if (!overProviderExpVariant.value) return null;
		return getPrimeShortName(country.value);
	});

	// hardcoded short name to override the config
	const overProvdiderHardcodedShortName = computed(() => {
		if (!overProviderExpVariant.value || country.value !== 'US') return undefined;
		return kickedInOverProviderShortName.value;
	});

	function setOverProviderExpTag(url: ClickoutUrl, placement: 'ro' | 'ft' | 'pr') {
		if (!overProviderExpVariant.value) return url;

		const variantShort =
			overProviderExpVariant.value === 'control' ? 'ct' : overProviderExpVariant.value.replace('variant_', 'v');
		const suffix = country.value === 'US' ? '20' : '21';
		const countryLower = country.value === 'IT' ? 'ita' : country.value.toLowerCase();

		const tag = `op3-${countryLower}-${placement}-${variantShort}-${suffix}`;

		return url.setOnOffer('tag', tag).set('uct_ctag', tag).skipYieldOptimization().skipUCT2();
	}

	return {
		kickedInOverProviderShortName,
		setOverProviderExpTag,
		overProvdiderHardcodedShortName,
	};
}
